export default __webpack_public_path__ + "static/media/1001.c8f03191.png";